import { BirdType } from './huntConfig';
import { HuntBird } from './huntEngine';

export interface HuntSpriteSheet {
    frameWidth: number;
    frameHeight: number;
    frameCount: number;
}

export function drawSpriteFrame(
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
    sheet: HuntSpriteSheet,
    frameIndex: number,
    destX: number,
    destY: number,
    destW: number,
    destH: number
): void {
    const frame = ((frameIndex % sheet.frameCount) + sheet.frameCount) % sheet.frameCount;
    ctx.drawImage(
        img,
        frame * sheet.frameWidth,
        0,
        sheet.frameWidth,
        sheet.frameHeight,
        destX,
        destY,
        destW,
        destH
    );
}

export function getBirdFlyFrame(bird: HuntBird, reducedMotion: boolean): number {
    if (reducedMotion) {
        return 0;
    }
    return bird.frame;
}

export function getBirdSheetKey(type: BirdType, state: HuntBird['state']): string {
    if (state === 'fall') {
        return 'hitAfraid';
    }
    if (type === 'fast') {
        return 'fastFlap';
    }
    if (type === 'bonus') {
        return 'bonusFlap';
    }
    return 'normalFlap';
}
